import { BaseWidgetFormFields } from 'components/consumer-page-widgets/BaseWidgetFormFields';
import { FormCheckbox, FormSelectField, FormTextField } from 'ui';
import { TagType } from 'generated/graphql';
import { core } from 'types';

export const ALLOWED_BUTTON_ARRAY_TAG_TYPES: TagType[] = ['WINE_FLAVOR', 'WINE_VARIETAL'];

export interface ButtonArrayWidgetFields extends BaseWidgetFormFields {
  heading: string;
  buttonCountLimit: number;
  buttonCountLimitDesktop: number;
  aggregationCountMinimum: number;
  tagType: core.MetaTag.TagType;
  includeVerticalSpacing: boolean;
}

export const ButtonArrayWidgetFormFields: React.FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  return (
    <>
      <FormTextField id="heading" name="heading" label="Heading" fullWidth />
      <FormTextField
        type="number"
        id="buttonCountLimit"
        name="buttonCountLimit"
        label="Button count limit"
        fullWidth
      />
      <FormTextField
        type="number"
        id="buttonCountLimitDesktop"
        name="buttonCountLimitDesktop"
        label="Button count limit (desktop)"
        fullWidth
      />
      <FormTextField
        type="number"
        id="aggregationCountMinimum"
        name="aggregationCountMinimum"
        label="Aggregation result minimum count"
        fullWidth
      />
      <FormSelectField
        id="tagType"
        name="tagType"
        label="Tag type"
        fullWidth
        InputLabelProps={{ shrink: true }}
      >
        {ALLOWED_BUTTON_ARRAY_TAG_TYPES.map((tagType) => {
          return <option key={tagType} value={tagType} label={tagType} />;
        })}
      </FormSelectField>
      <FormCheckbox
        label="Include vertical spacing"
        helperText="If this widget's background area (i.e., the color changing area) should be flush against the widget directly above, leave this unchecked"
        name="includeVerticalSpacing"
        id="includeVerticalSpacing"
      />
    </>
  );
};
